<template>
    <ModalFormCard :action="null" class="modal-default wide">
        <template #title>Upload files</template>

        <template #default="{ saving, errors }">
            <div v-if="deals != undefined && deals != null" class="grid grid-cols-1 gap-3 pb-4">
                <CanHaveDeal
                    :contact-id="contactId"
                    :model-id="modelId"
                    :model-type="modelType"
                    :deals="deals"
                    @updatedDealId="updatedDealId"
                />
            </div>

            <Select
                v-model:value="folder"
                :options="folders"
                label="Select or create a folder"
                menuClass="!bg-grey"
                name="folder"
                selectClass="!bg-grey text-15"
            />

            <Input
                v-if="folder == null"
                v-model:value="newFolder"
                class="mt-4"
                groupClass="!bg-grey text-15"
                label="New folder name"
                name="new"
            />

            <p class="text-14 text-grey-900 pb-1 mt-4">Drag your documents, photos, or videos here to start uploading</p>

            <label class="h-[158px] border-2 border-grey-500 border-dashed bg-grey-300 flex flex-col items-center justify-center relative">
                <input
                    ref="file"
                    :disabled="!canUpload"
                    class="absolute inset-0 w-full opacity-0 appearance-none"
                    multiple="multiple"
                    type="file"
                    v-on:change="handleFileUpload()"
                />

                <p class="text-14 text-grey-900">Drag & Drop your files here</p>
                <p class="text-14 text-grey-900 mt-1">OR</p>
                <button
                    :disabled="!canUpload"
                    class="bg-black hover:black-on-white text-white text-13 h-10 px-8 font-semibold mt-3 cursor-pointer z-10 !w-fit"
                    type="button"
                    @click="$refs.file.click()"
                >
                    Upload
                </button>
            </label>

            <div class="">
                <UploadBlock
                    v-for="file in files"
                    :file="file.file"
                    :formData="file.formData"
                    @error="uploadedCount++"
                    @uploaded="uploaded"
                />
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'
import UploadBlock from '~/components/customer/input/upload-block.vue'
import CanHaveDeal from '~/components/customer/blocks/can-have-deal.vue'

export default {
    mixins: [Modal],

    created() {
        this.requiresCRMFunds()
    },

    data() {
        return {
            files: [],
            dealId: null,
            folder: this.options.folder != undefined ? this.options.folder : this._options.folders[0].id,
            newFolder: '',
            uploadedCount: 0,
            deals: this._options?.deals,
        }
    },

    methods: {
        updatedDealId(id) {
            this.dealId = id

            if (!this.folders.find((f) => f.id == this.folder)) {
                this.folder = this.options.folder != undefined ? this.options.folder : this._options.folders[0].id
            }
        },

        clearFiles() {
            this.files = []
            this.newFolder = ''
        },

        handleFileUpload() {
            for (let i = 0; i < this.$refs.file.files.length; i++) {
                this.uploadFile(this.$refs.file.files[i])
            }
        },

        uploaded() {
            this.uploadedCount++

            if (this.uploadedCount == this.files.length) {
                // this.$authSanctum.getUser(true)
                this.$event.$emit('modal-form-completed')
                this.$event.$emit('modal-close')
                this.clearFiles()

                if (this.uploadedCount > 1) {
                    this.$event.$emit('toast-new-message', this.uploadedCount + ' ' + this.$help.pluralize('file', this.uploadedCount) + ' uploaded')
                } else {
                    this.$event.$emit('toast-new-message', 'File uploaded')
                }
            }
        },

        uploadFile(file) {
            let formData = new FormData()
            formData.append('belongs_type', this.dealId != null ? 103 : parseInt(this.options.modelType))
            formData.append('belongs_id', this.dealId != null ? this.dealId : parseInt(this.options.modelId))
            formData.append('file', file)
            formData.append('folder_id', this.folder)
            formData.append('new', this.newFolder)

            this.files.push({
                file: file,
                formData: formData,
            })
        },
    },

    computed: {
        folders() {
            let folders = [
                {
                    value: null,
                    html: 'Create new folder',
                },
            ]

            folders.push(
                ...this._options.folders
                    .filter((f) => {
                        // console.log(f)
                        if (this.dealId != null && f.key == 'folder') {
                            return false
                        }

                        return true
                    })
                    .map((f) => {
                        return {
                            value: f.id,
                            html: this.$help.capitalizeFirstLetter(f.name),
                        }
                    }),
            )

            if (this.dealId != null) {
                let deal = this.deals.find((d) => d.id == this.dealId)
                // console.log(deal)

                folders.push(
                    ...deal.folders.map((f) => {
                        return {
                            value: f.id,
                            html: this.$help.capitalizeFirstLetter(f.name),
                        }
                    }),
                )
            }

            return folders
        },

        canUpload() {
            return (this.folder == null && this.newFolder != '') || this.folder != null
        },

        // folders() {
        // 	let folders = [{
        // 		value: null,
        // 		html: "Create new folder",
        // 	}];

        // 	folders.push(...this.defaults.map((folder) => {
        // 		return {
        // 			value: folder.id,
        // 			html: this.$help.capitalizeFirstLetter(folder.name)
        // 		}
        // 	}))

        // 	return folders;
        // }

        // folders() {
        // 	let fs = this.$authSanctum.getUser().uploadFolders(),
        // 		f = {};

        // 	for (let i = 0; i < fs.length; i++) {
        // 		f[fs[i]] = 0;
        // 	}

        // 	if (this._options.uploads == null) {
        // 		return f;
        // 	}

        // 	for (let i = 0; i < this._options.uploads.length; i++) {
        // 		if (f[this._options.uploads[i].folder] == undefined) {
        // 			f[this._options.uploads[i].folder] = 1;
        // 		} else {
        // 			f[this._options.uploads[i].folder]++;
        // 		}
        // 	}

        // 	return f;
        // },

        // createFolders() {
        // 	let a = [{ value: "Create new folder" }];

        // 	Object.keys(this.folders).forEach((value) => {
        // 		a.push({
        // 			value: value,
        // 		});
        // 	});

        // 	return a;
        // },
    },

    components: {
        UploadBlock,
        CanHaveDeal,
    },
}
</script>
